/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Calm_Deer_GrazeInputs */

const en_mild_calm_deer_graze = /** @type {(inputs: Mild_Calm_Deer_GrazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Survey rounds and data`)
};

const de_mild_calm_deer_graze = /** @type {(inputs: Mild_Calm_Deer_GrazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungsrunden und Daten`)
};

/**
* | output |
* | --- |
* | "Survey rounds and data" |
*
* @param {Mild_Calm_Deer_GrazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_calm_deer_graze = /** @type {((inputs?: Mild_Calm_Deer_GrazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Calm_Deer_GrazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_calm_deer_graze(inputs)
	return de_mild_calm_deer_graze(inputs)
});